module.exports = __webpack_public_path__ + "img/chatou.prt.970c8e14.jpg";